module.exports = __webpack_public_path__ + "static/media/WhiskersWhimsiesFrame.f0e43539.png";